module.exports = __webpack_public_path__ + "img/laugh.f8e0be4c.gif";